import React, { FC, useState, useEffect, useContext, useRef } from 'react'
import ItemsCarousel from 'react-items-carousel'
import { isMobile, isTablet } from 'react-device-detect'
import cookie from 'react-cookies'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import history from '../../history'
import { Modal } from 'react-responsive-modal'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericColumn from '../../GenericComponents/GenericColumn'
import { SwitchContainer } from '../Challenges/style'

import { albumType } from '../../utils/albumCategories'

import Loader from '../Loader/Loader'

import {
  getFolders,
  getUserData,
  getMainpageAds,
  getMissingSteps,
  getPromoInfo,
} from '../../Api/backendApi'
import AppContext from '../../context/appContext'

import MainpageCarousel from './views/MainpageCarousel'
import DemoUserRedirectToSubModal from './views/DemoUserRedirectToSubModal'
import NewSubPromoModal from './views/NewSubPromoModal'

import MainScreenAdPlaceholder from '../../assets/REDESIGN_Assets/MainScreen/ad-placeholder-large.png'
import ThemeLighticon from '../../assets/REDESIGN_Assets/theme/switch-to-light-theme-icon.svg'
import ThemeDarkIcon from '../../assets/REDESIGN_Assets/theme/switch-to-dark-theme-icon.svg'

import {
  MainScreenBanner,
  MainPageLinkButton,
  BannerShopButton,
  BannerDietButton,
  MainScreenPromoBanner,
} from './styles/MainScreenStyles'

import DietAdBanner from '../../assets/REDESIGN_Assets/MainScreen/diet-ad-banner.jpg'
import GenericButton from '../../GenericComponents/GenericButton'
import { FaLessThanEqual } from 'react-icons/fa'

interface MainscreenInterface {
  setUserName: Function
}

export const modalStyles = {
  closeButton: {
    display: 'none',
  },
  modal: {
    maxWidth: 'unset',
    width: isMobile || isTablet ? '95vw' : '45vw',
    overflow: 'unset',
    left: '0',
    boxsizing: 'border-box',
    margin: isMobile || isTablet ? 'auto' : 'unset',
    borderRadius: '30px',
  },
}

const Mainscreen: FC<MainscreenInterface> = ({}) => {
  const appContext = useContext(AppContext)
  const { promiseInProgress } = usePromiseTracker()

  const [folders, setFolders] = useState()
  const [user, setUser] = useState(Object)
  const [isDemoMode, setDemoMode] = useState(cookie.load('userDemoMode'))
  const [activeLink, setActiveLink] = useState('')
  const [adds, setAddsData] = useState(Object)
  const [fixedUrl, setFixedUrl] = useState('')
  const [missingSteps, setMissingSteps] = useState([])
  const [isDemoUserRedirectToSubModalOpen, setDemoUserRedirectToSubModalOpen] =
    useState(false)
  const [isNewSubPromoModalOpen, setNewSubPromoModalOpen] = useState(false)
  const [promoInfo, setPromoIfno] = useState(null)

  const carousel1Ref: any = useRef(null)
  const carousel2Ref: any = useRef(null)
  const carousel3Ref: any = useRef(null)
  const carousel4Ref: any = useRef(null)
  const carousel5Ref: any = useRef(null)
  const carousel6Ref: any = useRef(null)
  const carousel7Ref: any = useRef(null)

  useEffect(() => {
    obtainUser()
    // obtainMissingSteps()
    obtainFolders()
    obtainAdds()
    obtainPromoInfo()
  }, [])

  useEffect(() => {
    if (
      (promoInfo &&
        promoInfo.promo_status &&
        promoInfo.promo_status == 'PROMO_DIALOG') ||
      (promoInfo &&
        promoInfo.promo_status &&
        promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
      (promoInfo &&
        promoInfo.promo_status &&
        promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
    ) {
      openPromoModal()
    }
  }, [promoInfo])

  const obtainMissingSteps = async () => {
    const steps: any = await getMissingSteps()
    setMissingSteps(steps && steps.missing_steps)
  }

  const obtainPromoInfo = async () => {
    const promoInfo = await getPromoInfo()

    await setPromoIfno(promoInfo)
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user: any = await trackPromise(getUserData())
    setUser(user)
    appContext.updateAppState('user', user)

    if (user.has_subscription) {
      cookie.remove('userDemoMode', { path: '/' })
      setDemoMode(false)
    } else {
      cookie.save('userDemoMode', true, { path: '/' })
      setDemoMode(true)
    }
  }

  const obtainFolders = async () => {
    if (appContext.appState.albums) {
      setFolders(appContext.appState.albums)
    }

    let folders = await trackPromise(getFolders())
    setFolders(folders)
    appContext.updateAppState('albums', folders)
  }

  const obtainAdds = async () => {
    if (appContext.appState.adds) {
      setAddsData(appContext.appState.adds)
    }

    let addsData: any = await trackPromise(getMainpageAds())

    setAddsData(addsData)

    appContext.updateAppState('adds', addsData)
  }

  const handleChangeActiveLink = (e: any) => {
    setActiveLink(e.target.id)

    if (e.target.classList.contains('active')) {
      return
    } else {
      const allElements = Array.from(
        document.getElementsByClassName('link-button')
      )

      allElements &&
        allElements.forEach((element: any) => {
          element.classList.contains('active') &&
            element.id !== e.target.id &&
            element.classList.remove('active')
        })
      e.target.classList.add('active')
    }

    switch (e.target.id) {
      case albumType.pozaMiazga.name:
        carousel1Ref.current.scrollIntoView()
        break
      case albumType.treningiMiazga.name:
        carousel2Ref.current.scrollIntoView()
        break
      case albumType.zrobSzpagat.name:
        carousel3Ref.current.scrollIntoView()
        break
      case albumType.treningiDodatkowe.name:
        carousel4Ref.current.scrollIntoView()
        break
      case albumType.dietaKuchnia.name:
        carousel5Ref.current.scrollIntoView()
        break
      case albumType.zdrowie.name:
        carousel6Ref.current.scrollIntoView()
        break
      default:
        break
    }
  }

  const closePromoModal = () => {
    let midnight = new Date()
    midnight.setHours(24, 59, 59, 0)

    cookie.save('closedPromoModal', true, { expires: midnight })
    setNewSubPromoModalOpen(false)
  }
  const openPromoModal = () => {
    if (!cookie.load('closedPromoModal')) {
      setNewSubPromoModalOpen(true)
    }
  }

  const redirectUserToPromoSubSelect = () => {
    if (
      promoInfo &&
      promoInfo.promo_status &&
      promoInfo.promo_status == 'MIAZGA_NUTSHELL'
    ) {
      history.push('/wybierz-plan/sub', { mode: 'w-pigulce' })
    } else {
      history.push('/wybierz-plan/sub', { promo: true })
    }
  }

  const switchToChallenge = () => {
    history.push('/wyzwania')
  }

  return (
    <GenericBackgroundLayer
      justify={'flex-start'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } mainpage`}
    >
      <NavigationBar isPlayerView={false} backButtonAction={null} />
      {((promoInfo && promoInfo.promo_status == 'PROMO_DIALOG') ||
        (promoInfo &&
          promoInfo.promo_status &&
          promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
        (promoInfo &&
          promoInfo.promo_status &&
          promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')) && (
        <MainScreenPromoBanner>
          <GenericRow>
            <GenericTextSpan
              fSize="1.5rem"
              margin={isMobile ? '0 2% 0 0' : '0 5% 0 0'}
              color="#342152"
            >
              &#x276F; &#x276F; &#x276F;
            </GenericTextSpan>
            <GenericTextSpan
              fSize="1.8rem"
              margin={isMobile ? '0' : '0 5% 0 0'}
              color="#342152"
              fWeight="bold"
              tAlign="center"
            >
              {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                ? 'Trwa promocja na MIAZGĘ w pigułce'
                : promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG'
                ? 'Trwa promocja na MIAZGĘ w pigułce i MIAZGĘ'
                : 'Trwa promocja na MIAZGĘ'}
            </GenericTextSpan>
            {!isMobile && (
              <GenericButton
                onClick={redirectUserToPromoSubSelect}
                justify="center"
                className="promo-banner-filled-btn"
              >
                SKORZYSTAJ!
              </GenericButton>
            )}
            <GenericTextSpan
              margin={isMobile ? '0 0 0 2%' : '0 0 0 5%'}
              fSize="1.5rem"
              color="#342152"
            >
              &#x276E; &#x276E; &#x276E;
            </GenericTextSpan>
          </GenericRow>
          {isMobile && (
            <GenericRow>
              <GenericButton
                onClick={redirectUserToPromoSubSelect}
                justify="center"
                className="promo-banner-filled-btn"
              >
                SKORZYSTAJ!
              </GenericButton>
            </GenericRow>
          )}
        </MainScreenPromoBanner>
      )}
      <MainScreenBanner>
        {/* <GenericIcon
          src={adds && adds.img_url}
          className={'mainpage-diet-banner__first'}
          // src={MainScreenAdPlaceholder}
          height={
            window.innerWidth > 360 && !isTablet
              ? '13vh'
              : isTablet
              ? '9vh'
              : '17vh'
          }
          width={isMobile || isTablet ? '100%' : '50%'}
          backgroundSize={isMobile || isTablet ? '100% 100%' : '100% 100%'}
          backgroundPosition={'top'}
          onClick={() => (window.location.href = adds && adds.promo_url)}
        >
          <BannerShopButton className="first-banner">
            Odwiedź sklep
          </BannerShopButton>
        </GenericIcon> */}
        <GenericIcon
          onClick={
            user && user.diet_panel_access ? () => history.push('/dieta') : null
          }
          src={DietAdBanner}
          height={
            window.innerWidth > 360 && !isTablet
              ? '13vh'
              : isTablet
              ? '9vh'
              : '17vh'
          }
          backgroundPosition={'top'}
          width={'100%'}
          backgroundSize={isMobile || isTablet ? '100% 100%' : 'cover'}
          className={'mainpage-diet-banner mainpage-diet-banner__second'}
          // borderRadius={isMobile ? '30px' : 'unset'}
        >
          <BannerDietButton>Wybierz swoją dietę </BannerDietButton>
        </GenericIcon>
      </MainScreenBanner>

      <GenericRow
        className="mainpage-header-row"
        padding={isMobile ? '10px' : 'unset'}
        wrap={isMobile ? 'wrap' : 'unset'}
        margin={'1% auto'}
        width={isMobile ? '100%' : '60%'}
      >
        <GenericColumn width={isMobile ? '100%' : '20%'}>
          <GenericRow justify={'space-between'} padding={'0 5px'}>
            <GenericTextSpan
              fSize={'2.5rem'}
              margin={'2% 0 1% 0%'}
              tAlign={'left'}
              display={'block'}
              fWeight={'bold'}
              className={`${
                appContext.appState.theme == 'light' ? 'light' : ''
              }`}
            >
              Cześć {user && user.name}
            </GenericTextSpan>
            {isMobile && (
              <GenericIcon
                src={
                  appContext.appState.theme == 'dark'
                    ? ThemeLighticon
                    : ThemeDarkIcon
                }
                onClick={() =>
                  appContext.appState.theme == 'dark'
                    ? appContext.updateAppState('theme', 'light')
                    : appContext.updateAppState('theme', 'dark')
                }
                width={'7vw'}
                height={'7vw'}
                className="mainpage-switch-theme"
              />
            )}
          </GenericRow>
          <GenericRow padding={'0 5px'} justify={'flex-start'}>
            <GenericTextSpan
              opacity={'0.85'}
              display={'block'}
              margin={'0% 0 1% 0%'}
              fSize={'1.3rem'}
              className={`${
                appContext.appState.theme == 'light' ? 'light' : ''
              }`}
            >
              Super, że jesteś
            </GenericTextSpan>
          </GenericRow>
        </GenericColumn>

        <GenericColumn
          width={isMobile ? '100%' : '80%'}
          margin={isMobile ? '3% 0 5% 0px ' : 'unset'}
        >
          <GenericRow wrap={isMobile ? 'wrap' : 'unset'} justify={'flex-start'}>
            {Object.keys(albumType).map(
              (key) =>
                albumType[key].label !== 'Przygotowanie do wyzwań' && (
                  <MainPageLinkButton
                    onClick={(e: any) => handleChangeActiveLink(e)}
                    key={albumType[key].name}
                    id={albumType[key].name}
                    className={`${
                      appContext.appState.theme == 'light' ? 'light' : ''
                    } link-button`}
                  >
                    {albumType[key].label}
                  </MainPageLinkButton>
                )
            )}
          </GenericRow>
        </GenericColumn>
      </GenericRow>

      <GenericRow
        className="mainpage-header-row"
        padding={isMobile ? '10px' : 'unset'}
        wrap={isMobile ? 'wrap' : 'unset'}
        margin={'1% auto'}
        width={isMobile ? '100%' : '60%'}
      >
        <GenericRow margin={isMobile ? '7% 0' : '2% 0'} justify="flex-start">
          <SwitchContainer>
            <GenericTextSpan margin="0 5px 0 0">
              Pełna wersja MIAZGI
            </GenericTextSpan>
            <label className="switch full">
              <input type="checkbox" onChange={switchToChallenge} />
              <span className="slider round"></span>
            </label>
            <GenericTextSpan margin="0 0 0 5px">Wyzwania</GenericTextSpan>
          </SwitchContainer>
        </GenericRow>
      </GenericRow>

      {/* Poza miazgą CAROUSEL */}
      <div ref={carousel1Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          isConferences={false}
          onClick={undefined}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.pozaMiazga.name}
          albumName={albumType.pozaMiazga.label}
          categoryTag={albumType.pozaMiazga.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {/* Treningi miazga CAROUSEL */}
      <div ref={carousel2Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          isConferences={false}
          onClick={undefined}
          // ref={carousel2Ref}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.treningiMiazga.name}
          albumName={albumType.treningiMiazga.label}
          categoryTag={albumType.treningiMiazga.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {/* NOWE WYZWANIA */}
      <div ref={carousel7Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          onClick={undefined}
          isConferences={false}
          // ref={carousel6Ref}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.newChallenges.name}
          albumName={albumType.newChallenges.label}
          categoryTag={albumType.newChallenges.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {/* Zrób szpagat CAROUSEL */}
      <div ref={carousel3Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          isConferences={false}
          onClick={undefined}
          // ref={carousel3Ref}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.zrobSzpagat.name}
          albumName={albumType.zrobSzpagat.label}
          categoryTag={albumType.zrobSzpagat.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {/* Treningi dodatkowe CAROUSEL */}
      <div ref={carousel4Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          onClick={undefined}
          isConferences={false}
          // ref={carousel4Ref}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.treningiDodatkowe.name}
          albumName={albumType.treningiDodatkowe.label}
          categoryTag={albumType.treningiDodatkowe.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {/* Dieta i kuchnia CAROUSEL */}
      <div ref={carousel5Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          onClick={undefined}
          // ref={carousel5Ref}
          isConferences={false}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.dietaKuchnia.name}
          albumName={albumType.dietaKuchnia.label}
          categoryTag={albumType.dietaKuchnia.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {/* Zdrowie psychiczne i fizyczneCAROUSEL */}
      <div ref={carousel6Ref}>
        <MainpageCarousel
          conferencesTrainings={false}
          fullWidth={false}
          onClick={undefined}
          isConferences={false}
          // ref={carousel6Ref}
          isDemoMode={isDemoMode}
          folders={folders}
          albumType={albumType.zdrowie.name}
          albumName={albumType.zdrowie.label}
          categoryTag={albumType.zdrowie.tag}
          setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
          promoInfo={promoInfo}
        />
      </div>

      {promiseInProgress &&
        (!appContext.appState.albums || !appContext.appState.user) && (
          <Loader />
        )}
      <Modal
        open={isDemoUserRedirectToSubModalOpen || isNewSubPromoModalOpen}
        animationDuration={700}
        onClose={
          isDemoUserRedirectToSubModalOpen
            ? () => setDemoUserRedirectToSubModalOpen(false)
            : () => closePromoModal()
        }
        center
        styles={modalStyles}
      >
        {isDemoUserRedirectToSubModalOpen && (
          <DemoUserRedirectToSubModal
            closeModal={() => setDemoUserRedirectToSubModalOpen(false)}
          />
        )}
        {isNewSubPromoModalOpen && (
          <NewSubPromoModal
            promoInfo={promoInfo}
            closeModal={() => closePromoModal()}
            redirectUserToPromoSubSelect={redirectUserToPromoSubSelect}
          />
        )}
      </Modal>
    </GenericBackgroundLayer>
  )
}

export default Mainscreen
